import { render, staticRenderFns } from "./McToastAlertCloseButton.vue?vue&type=template&id=10e0ec6a&"
var script = {}
import style0 from "./McToastAlertCloseButton.vue?vue&type=style&index=0&id=10e0ec6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports